/** Auto-refresh must not reset 'Vis ældre' paging or cancel that request. */
export function shouldSkipCorrespondenceAutoRefresh(input: {
  offset: number;
  requestInFlight: boolean;
}): boolean {
  return input.offset > 0 || input.requestInFlight;
}
